module.exports = __webpack_public_path__ + "static/images/myoffspring_logo.597770f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myoffspring_logo.png
// module id = RLpJ
// module chunks = 1